import {
  css,
  documentHead,
  footer,
  invoiceDetailsConfirmed,
  logo,
} from "./pieces";

const html = `${documentHead}
  <body>
    <div class="es-wrapper-color">
      <!--[if gte mso 9]>
      <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
        <v:fill type="tile" color="null"></v:fill>
      </v:background>
      <![endif]-->
      <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td class="esd-email-paddings" valign="top">
              <table class="esd-header-popover es-content" cellspacing="0" cellpadding="0" align="center">
                <tbody>
                  <tr>
                    <td class="esd-stripe" align="center">
                      <table class="es-content-body" width="600" cellspacing="0" cellpadding="0" align="center" style="background-color: transparent;">
                        <tbody>
                          ${logo}

                          <tr>
                            <td class="esd-structure es-p20t es-p20r es-p20l" align="left">
                              <table cellpadding="0" cellspacing="0" width="100%">
                                <tbody>
                                  <tr>
                                    <td width="600" class="esd-container-frame" align="center" valign="top">
                                      <table cellpadding="0" cellspacing="0" width="100%">
                                        <tbody>
                                          <tr>
                                            <td align="left" class="esd-block-text">
                                              <p><strong>ORDER PREP SHEET<br><br></strong>Use this as a checklist to ensure all items in this order are accounted for.<b></b><br></p>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <td class="esd-structure es-p20t es-p20r es-p20l" align="left">
                              <table cellpadding="0" cellspacing="0" width="100%">
                                <tbody>
                                  <tr>
                                    <td width="600" class="esd-container-frame" align="center" valign="top">
                                      <table cellpadding="0" cellspacing="0" width="100%">
                                        <tbody>
                                          <tr>
                                            <td align="left" class="esd-block-text">
                                              ${invoiceDetailsConfirmed}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      ${footer}
    </div>
  </body>
</html>`;

export { html, css };
